<ng-container *workspaceView="'full'">
<div class="workspace-page br-compact-page">
  <div class="workspace-page__panel workspace-page__panel--card">
    <header class="workspace-page__heading">
      <h1 class="workspace-page__title">{{ workflow?.label || 'Smart Workflow' }}</h1>
    </header>
  <div *ngIf="loading" class="workflow-state br-text-muted">Loading workflowâ€¦</div>
  <div *ngIf="!loading && errorMessage" class="workflow-state br-text-danger" role="alert">
    {{ errorMessage }}
  </div>

  <app-data-table
      *ngIf="!loading && workflow && !errorMessage"
      [columns]="columns"
      [fetch]="fetch"
      [filters]="filterValues"
      [editable]="true"
      [rowActions]="recordActions"
      [resizableColumns]="true"
      [searchable]="false"
      [columnPickerKey]="'smart-workflow-' + workflowKey"
      editTooltip="Edit record"
      emptyText="No data has been added to this workflow."
      (edit)="editRecord($event)">
    <app-data-filter
        dt-filters
        #filter
        [fields]="filterFields"
        [values]="filterValues"
        (change)="filter.apply()"
        (applied)="applyFilters($event)">
    </app-data-filter>

    <button dt-actions
            type="button"
            class="br-btn br-btn--outline-secondary br-btn--sm"
            [disabled]="exporting"
            (click)="exportCsv()">
      <br-icon>download</br-icon> {{ exporting ? 'Exportingâ€¦' : 'Export CSV' }}
    </button>
    <button dt-actions
            type="button"
            class="br-btn br-btn--outline-secondary br-btn--sm"
            [disabled]="importing"
            (click)="importCsv()">
      <br-icon>upload</br-icon> {{ importing ? 'Importingâ€¦' : 'Import CSV' }}
    </button>
    <button dt-actions
            type="button"
            class="br-btn br-btn--primary br-btn--sm"
            (click)="addRecord()">
      <br-icon>add</br-icon> Add record
    </button>

    <ng-template dtCell="id" let-row>
      <span class="br-cell-id">{{ row.id }}</span>
    </ng-template>
    <ng-template dtCell="currentNodeLabel" let-row>
      <span class="br-cell-pill">{{ row.currentNodeLabel }}</span>
    </ng-template>
    <ng-template dtCell="updatedAt" let-row>
      {{ row.updatedAt | date:'MMM d, y' }}
    </ng-template>
  </app-data-table>

  <ng-template #recordActions let-row>
    <button
        type="button"
        mat-icon-button
        matTooltip="Delete record"
        aria-label="Delete record"
        [disabled]="deletingRecordIds.has(row.id)"
        (click)="deleteRecord(row)">
      <br-icon>delete</br-icon>
    </button>
  </ng-template>
  </div>
</div>
</ng-container>

<ng-container *workspaceView="'compact'">
  <section class="workspace-page workspace-page--full">
    <h1 class="workspace-page__title">{{ workflow?.label || 'Smart Workflow' }}</h1>
    <p *ngIf="loading" role="status">Loading…</p><p *ngIf="errorMessage" role="alert">{{ errorMessage }}</p>
    <app-data-list #compactList [fetch]="fetch" [filters]="filterValues" [searchable]="false" *ngIf="!loading && workflow && !errorMessage">
      <app-data-filter list-filters #compactFilter [fields]="filterFields" [values]="filterValues" (change)="compactFilter.apply()" (applied)="applyFilters($event)"></app-data-filter>
      <ng-template dataListItem let-row>
        <strong>#{{ row.id }}</strong>
        <div class="br-text-muted">{{ row.currentNodeLabel }}</div>
      </ng-template>
      <ng-template dataListDetail let-row>
        <div>Updated: {{ row.updatedAt | date:'MMM d, y' }}</div>
      </ng-template>
    </app-data-list>
  </section>
</ng-container>
